export const Circle = ({ color, size = 8 }) => {
  return (
    <span
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        borderRadius: "50%",
        display: "inline-block",
      }}
    />
  );
};
